import { useRef } from "react";
import { NextPrevArrow } from "../../helper/Icons";
import { tabsData } from "../../helper/Helper";

function GameNav({ activeTab, setActiveTab }) {
  const tabListRef = useRef(null);

  const scrollLeft = () => {
    if (tabListRef.current) {
      const firstItem = tabListRef.current.firstChild;
      const itemWidth = firstItem.offsetWidth; // Get the width of the first item

      tabListRef.current.scrollBy({
        left: -itemWidth, // Scroll left by the width of the first item
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (tabListRef.current) {
      const firstItem = tabListRef.current.firstChild;
      const itemWidth = firstItem.offsetWidth; // Get the width of the first item

      tabListRef.current.scrollBy({
        left: itemWidth, // Scroll right by the width of the first item
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <div className="mb-2">
        <div className="tab-scroll-btn d-flex justify-content-end mb-3">
          <div className="d-flex gap-2 align-items-center">
            <button onClick={scrollLeft} className="btn bg-darkslate max-w-h-33 d-flex p-1">
              <NextPrevArrow />
            </button>
            <button onClick={scrollRight} className="btn bg-darkslate rotate-180 max-w-h-33 d-flex p-1">
              <NextPrevArrow />
            </button>
          </div>
        </div>

        <ul
          ref={tabListRef}
          className="d-flex align-items-center gap-2 mb-0 list-unstyled p-0 nav-game-tab overflow-auto"
          style={{ scrollBehavior: 'smooth', maxWidth: '100%' }}
        >
          {tabsData.map((tab, index) => (
            <li key={index}>
              <button
                className={`d-flex gap-2 align-items-center py-1 py-lg-2 px-lg-4 px-3 fs-18 ${activeTab === index ? "nav-active" : "nav-not-active"}`}
                onClick={() => setActiveTab(index)}
              >
                {tab.icon}
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default GameNav;
